<script setup>
import { reactive } from 'vue'
import DatePicker from 'vue-datepicker-next'
import 'vue-datepicker-next/index.css'
import ko from 'vue-datepicker-next/locale/ko.es'
import { QuillEditor } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css'
import { htmlToTxt, post, serverDt, validators, ymdhms } from '@/common/util'
import _ from 'lodash-es'
import ConfirmCard from '@/components/ConfirmCard.vue'
import { useMetaStore } from '@/stores'
import dayjs from 'dayjs'
import { onBeforeRouteUpdate } from 'vue-router'
import { useRouter,useRoute } from 'vue-router'
const meta=reactive({data:{rows:[]},search:{sortcol:'cdt',isasc:false,page:1,size:20},tblheight:400
    ,heads:[{tk:'title',col:'ttl'},{tk:'dateofenrollment',col:'cdt'},{tk:'author',col:'author'},{tk:'publishedon',col:'sdt'},{tk:'status',col:'status'},{tk:'viewdetails'},{tk:'delete'}]})
  ,metaStore=useMetaStore(),router=useRouter(),route=useRoute()
,mod=async(row)=>{
  delete row.author
  delete row.status
  if(row.sdt&&row.stime){
    const sdt=dayjs(row.sdt)
    const stime=dayjs(row.stime)
    row.sdt=sdt.hour(stime.hour()).minute(stime.minute()).second(stime.second()).millisecond(0).toDate()
    delete row.stime
  }
  row.sdt=serverDt(row.sdt)
  metaStore.blockLoading()
  const res=await post('rest/authed/admin/modnotice',row)
  metaStore.blockLoading(false)
  metaStore.toastRslt(res,meta.poptype=='save')
  search()
},pop=(type,row)=>{
  meta.poptype=null
  if(type=='save'){
    meta.popttl= metaStore.t('announcements')+' '+metaStore.t(meta.selrow.id?'viewdetails':'newregistration')
    meta.popcont= metaStore.t('save_con')
    row.etc=null
  }else if(type=='del'){
    row.etc='delete'
    meta.popttl= metaStore.t('announcements')+' '+metaStore.t('delete')
    meta.popcont= null
  }
  meta.popact=()=>mod({...row})
  metaStore.pop({ison:true,callback:() => meta.poptype=type})
},sort=col=>{
  if(!meta.data.rows.length)return
  if(meta.search.sortcol!=col)meta.search.sortcol=col
  else meta.search.isasc=!meta.search.isasc
  search()
},sel=row=>{
  if(row.enabled==null)row.enabled=true
  if(row.fixed==null)row.fixed=false
  if(!row.sdt)row.sdt=new Date
  if(!row.stime)row.stime=new Date
  if(!row.cont)row.cont=''
  meta.selrow={...row}
  router.push({hash: '#new_or_detail'})
},search=async()=>{
  meta.selrow=null
  metaStore.blockLoading()
  const res=await post('rest/authed/admin/notices',meta.search)
  const mems=res.data.subrows.mems
  res.data.rows.forEach(row=>{
    const mem=mems.find(mem=>mem.mid==row.mid)
    row.author=`${mem.mname}(${mem.mid})`
    const now=dayjs(),sdt=dayjs(row.sdt)
    row.status=now.diff(sdt)<0?'scheduling':'exposure'
    row.sdt=sdt.toDate()
    row.stime=sdt.toDate()
    if(!row.enabled)row.status='hidden'
  })
  metaStore.blockLoading(false)
  meta.tblheight=window.innerHeight-300
  meta.data=res.data
}
search()
onBeforeRouteUpdate((to, from) => {
  if(!to.hash||to.hash=='')meta.selrow=null
})
</script>
<template>
  <div class="admnotice">
    <v-card v-if="!meta.selrow" flat>
      <v-card-title>
        <v-row>
          <v-col>{{ $t('announcements') }}</v-col>
          <v-col class="text-right">
            <v-btn :text="$t('refresh')" @click="search"/>
            <v-btn class="ms-3" color="primary" :text="$t('newregistration')" @click="sel({})"/>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-table class="admnoticelist" fixed-header :height="meta.tblheight">
          <thead>
            <tr>
              <th v-for="head in meta.heads">
                <div v-if="['ttl','cdt','sdt'].includes(head.col)" class="cursor-pointer" @click="sort(head.col)">
                  {{ $t(head.tk) }}
                  <v-icon v-if="meta.data.rows.length&&head.col&&meta.search.sortcol==head.col" :icon="meta.search.isasc?'mdi-arrow-up':'mdi-arrow-down'"/>
                </div>
                <div v-else>{{ $t(head.tk) }}</div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="meta.data.rows.length==0"><td class="text-center" :colspan="meta.heads.length">{{ $t('noresultsfound') }}</td></tr>
            <tr v-else v-for="row in meta.data.rows">
              <td v-for="head in meta.heads" :class="'text-center '+head.tk">
                <div v-if="head.col=='cdt'||head.col=='sdt'">{{ ymdhms(row[head.col]) }}</div>
                <v-btn v-else-if="head.tk=='viewdetails'" :text="$t(head.tk)" @click="sel(row)"/>
                <v-btn v-else-if="head.tk=='delete'" color="error" :text="$t(head.tk)" @click="pop('del',row)"/>
                <div v-else-if="head.tk=='status'">{{ $t(row[head.col]) }}</div>
                <div v-else>{{ row[head.col] }}</div>
              </td>
            </tr>
          </tbody>
        </v-table>
      </v-card-text>
      <v-card-actions>
        <v-pagination class="ma-auto" v-if="meta.data.rows.length" :length="meta.data.totalPages" :total-visible="meta.data.pageCount" v-model="meta.search.page" @update:model-value="search"/>
      </v-card-actions>
    </v-card>
    <v-card v-else flat>
      <v-card-title>
        {{ $t('announcements') }} / {{ $t(meta.selrow.id?'viewdetails':'newregistration') }}
      </v-card-title>
      <v-card-text>
        <v-table class="detail">
          <tbody>
            <tr>
              <th>{{ $t('categories') }}</th>
              <td>
                {{ $t('announcements') }}
              </td>
              <th>{{ $t('status') }}</th>
              <td>
                {{ meta.selrow.status?$t(meta.selrow.status):'' }}
              </td>
            </tr>
            <tr>
              <th>{{ $t('ishidden') }}</th>
              <td>
                <v-radio-group inline hide-details v-model="meta.selrow.enabled">
                  <v-radio :label="$t('exposure')" :value="true"/>
                  <v-radio :label="$t('hidden')" :value="false"/>
                </v-radio-group>
              </td>
              <th>{{ $t('fixedtop') }}</th>
              <td>
                <v-radio-group inline hide-details v-model="meta.selrow.fixed">
                  <v-radio :label="$t('fixed')" :value="true"/>
                  <v-radio :label="$t('unfixed')" :value="false"/>
                </v-radio-group>
              </td>
            </tr>
            <tr>
              <th>{{ $t('publishedon') }}</th>
              <td colspan="3">
                <DatePicker :lang="ko" style="width: 120px;" :value="meta.selrow.sdt" @update:value="val=>meta.selrow.sdt=val"/>
                <DatePicker :lang="ko" style="width: 120px;" class="ms-3" :value="meta.selrow.stime" type="time" @update:value="val=>meta.selrow.stime=val"/>
              </td>
            </tr>
            <tr>
              <th>{{ $t('title') }}</th>
              <td colspan="3">
                <v-text-field variant="outlined" density="compact" class="mt-5" :placeholder="$t('pleaseenteratitleupto50characters')" v-model="meta.selrow.ttl" :rules="[validators.required]"/>
              </td>
            </tr>
            <tr>
              <th>{{ $t('contents') }}</th>
              <td colspan="3" class="h-100 pa-3">
                <QuillEditor theme="snow" content-type="html" :content="meta.selrow.cont" @update:content="html=>meta.selrow.cont=html"/>
                  <div class="v-messages mt-2"><div class="v-messages__message" style="color: rgb(var(--v-theme-error));">{{htmlToTxt(meta.selrow.cont)==''?$t('pleaseconfirmtheinformationyouentered'):'' }}</div></div>
              </td>
            </tr>
            <tr>
              <th>{{ $t('author') }}</th>
              <td colspan="3">
                {{ meta.selrow.author }}
              </td>
            </tr>
          </tbody>
        </v-table>
      </v-card-text>
      <v-card-actions>
        <v-row justify="end">
          <v-btn variant="elevated" :text="$t('cancel')" @click="meta.selrow=null"/>
          <v-btn variant="elevated" color="primary" class="ms-5 me-5" :text="$t('save')" :disabled="validators.required(meta.selrow.ttl)!==true||htmlToTxt(meta.selrow.cont)==''" @click="pop('save',meta.selrow)"/>
        </v-row>
      </v-card-actions>
    </v-card>
  </div>
  <Teleport v-if="meta.poptype" to="#popbody">
    <ConfirmCard :ttl="meta.popttl" :cont="meta.popcont" @cancel="metaStore.pop({ison:false})" @confirm="meta.popact"/>
  </Teleport>
</template>
<style>
.admnotice .detail{border: 1px solid #e0e0e0;}
.admnotice th{background-color: #eee;text-align: center !important;}
.admnotice .ql-container{height: 400px;}
.admnoticelist .status{width: 100px;}
</style>
